import { ControllerProps, FieldValues } from "react-hook-form";
import { SelectionOption } from "../../../types";
import {
  ItecToggleButtonGroupMultiple,
  ItecToggleButtonGroupMultipleProps,
} from "./toggle-button-group-multiple";
import { useField } from "../../../hooks";
import { FormControl, FormHelperText, FormLabel } from "@mui/material";

export type ControlledToggleButtonGroupMultipleProps<
  TOption extends SelectionOption,
  TForm extends FieldValues
> = Required<Pick<ControllerProps<TForm>, "control" | "name">> & {
  /**
   * TODO: async options
   */
  /**
   * At least one value must be selected at all times.
   */
  enforceValueSet?: boolean;
  helperText?: string;
  label?: string;
} & Omit<ItecToggleButtonGroupMultipleProps<TOption>, "onChange" | "value">;

export function ControlledToggleButtonGroupMultiple<
  TOption extends SelectionOption,
  TForm extends FieldValues
>(props: ControlledToggleButtonGroupMultipleProps<TOption, TForm>) {
  const {
    name,
    control,
    label,
    helperText,
    enforceValueSet,
    options,
    ...rest
  } = props;

  const { field, fieldState, formState } = useField<TOption[], TForm>({
    name,
    control,
  });

  const handleChange = (value: number[]) => {
    if (!value.length && enforceValueSet) return;

    field.onChange(options.filter((v) => value.includes(v.value)));
  };

  return (
    <FormControl error={!!fieldState.error}>
      {label && <FormLabel>{label}</FormLabel>}
      <ItecToggleButtonGroupMultiple
        value={field.value?.map((v) => v.value) ?? []}
        onChange={handleChange}
        options={options}
        {...rest}
      />
      <FormHelperText>
        {fieldState.error?.message || (helperText && helperText)}
      </FormHelperText>
    </FormControl>
  );
}
